// Route-level admin guard. The verdict comes from the server (/auth/me), not
// from anything the client can edit: authStore's role lives in localStorage
// and is trivially forgeable, which is why it is not consulted here. The API
// already enforces RequireAdmin on every admin endpoint, so data was never
// reachable; this closes the remaining half, so a non-admin who types /users
// into the address bar never mounts the page at all. Fail-closed: no server
// answer, no admin surface.
import { Navigate, Outlet } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { meApi } from '../api/client'
import { Spinner } from './ui'

export default function RequireAdmin() {
  const { data: me, isLoading } = useQuery({
    queryKey: ['me'],
    queryFn: meApi.get,
    staleTime: 5 * 60 * 1000,
  })

  if (isLoading) {
    return (
      <div className="flex justify-center py-16">
        <Spinner className="w-6 h-6 text-gray-400" />
      </div>
    )
  }
  if (!me || me.role !== 'admin') return <Navigate to="/dashboard" replace />
  return <Outlet />
}
